import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';

import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const SyllabusStructureSubject = () => {
    const authorizedAxios = generateAxiosInstance()

    const initialFormState = {
        subjectMasterId: '',
        syllabusStructureMasterId: '',
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [PdfBookData, setPdfBookData] = useState(initialFormState)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["syllabusStructureName", "subjectMasterDetails.subjectName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            handleRefresh();
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (PdfBookData.syllabusStructureMasterId !== '') {
                setCurrPage(1);
                let apiUrl = `/syllabus-structure-wise-subjects?id=${PdfBookData.syllabusStructureMasterId}`;

                apiUrl = apiUrl.replace(/&$/, '');
                setSubjectList(await searchArray("A", apiUrl, searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        getSyllabusList();
    }, []);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
                console.log('Syllabus List :', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(syllabusList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(subjectList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subjectList.length) {
            endIndex = subjectList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(subjectList.slice(startIndex, endIndex));
    }, [subjectList, currPage, itemsPerPage]);

    const handleRefresh = (e) => {
        if (PdfBookData.syllabusStructureMasterId !== '') {
            setLoading(true);
            const apiUrl = `/syllabus-structure-wise-subjects?id=${PdfBookData.syllabusStructureMasterId}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubjectList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const handleSyllabusChange = (e) => {
        setLoading(true);
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
            }
        })
        const apiUrl = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const deleteSubject = (syllabusId, subjectMasterId, subjectMappingId) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-syllabus-structure-wise-subjects?syllabusStructureMasterId=${syllabusId}&subjectMasterId=${subjectMasterId}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, subjectList.length);
                    handleRefresh();
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        title: errorMsg,
                        text: 'Do you want to delete forcefully?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showLoaderOnConfirm: true,
                        preConfirm: async () => {
                            return Swal.fire({
                                html: `
                                    <div>
                                        <p>Enter Administrative Password:</p>
                                        <input type="password" id="swal-input" class="swal2-input" placeholder="Password">
                                    </div>
                                `,
                                showCancelButton: true,
                                confirmButtonText: 'Submit',
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    const inputValue = document.getElementById('swal-input').value;
                                    const confirmAPIurl = `/force-delete-syllabus-structure-wise-subjects?id=${subjectMappingId}&password=${inputValue}`;
                                    authorizedAxios && authorizedAxios.delete(confirmAPIurl)
                                        .then(response => {
                                            // setSubjectList((prevList) => [...prevList].filter((list) => list.subjectMasterDetails.id !== subjectMasterId))

                                            const page = deleteItem(currPage, itemsPerPage, subjectList.length);
                                            handleRefresh();
                                            setCurrPage(page);

                                            Swal.fire(
                                                { text: response.data.message }
                                            );
                                        })
                                        .catch(error => {
                                            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                                            Swal.fire(
                                                { text: errorMsg }
                                            );
                                        });
                                }
                            });
                        }
                    }).then((result) => {
                        console.log('Confirmation result:', result);
                    }).catch((error) => {
                        console.error('Error:', error);
                    });
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setSubjectSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusNameSort(null);
        }
    }, [subjectSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>

                            <li className="breadcrumb-item active"><span>Syllabus Structure's Subject</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-layer-group"></i> Syllabus Structure's Subject </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={PdfBookData.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {PdfBookData.syllabusStructureMasterId && PdfBookData.syllabusStructureMasterId.length > 0 && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus
                                                                            <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setSubjectList} setCurrPage={setCurrPage} sortingPath={"syllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSubjectList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((subject, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{subject.syllabusStructureName}</td>
                                                                                        <td>{subject.subjectMasterDetails.subjectName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteSubject(subject.id, subject.subjectMasterDetails.id, subject.syllabusStructureSubjectMappingId)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Subjects Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subjectList.length} />

                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SyllabusStructureSubject;